import type React from 'react';

interface ButtonBadgeProps {
  text?: string;
}

export const ButtonBadge: React.FC<ButtonBadgeProps> = ({ text }) => {
  return (
    <>
      {typeof text !== 'undefined' && (
        <div className="absolute -bottom-[12px] -right-[5px] hidden rounded-3xl border border-solid border-cardAnswerButtonColor bg-badgeColor px-[5px] py-0.5 font-RobotoCondensed text-xs font-semibold tracking-[0px] text-cardAnswerButtonColor sm:block">
          {text.toUpperCase()}
        </div>
      )}
    </>
  );
};
